export class ServiceTypeModel {
    id: number;
    name: string | '';
    isActive: boolean;
    shiftId: number;
    rateType: 'global' | 'special' | '';
    chargeRateScopeId: number;
    payRateScopeId: number;
    categoryId: number;
    timeWindows: Array<any>;
    breakDuration: Array<any>;
    serviceDuration: Array<any>;
    roles: Array<any>;
    vehicleTypes: Array<any>;
    machshipServiceId: number;
    constructor () {
        this.id = 0;
        this.name = '';
        this.isActive = true;
        this.shiftId = 0;
        this.rateType = '';
        this.chargeRateScopeId = 0;
        this.payRateScopeId = 0;
        this.categoryId = 0;
        this.timeWindows = [];
        this.breakDuration = [];
        this.serviceDuration = [];
        this.roles = [];
        this.vehicleTypes = [];
        this.machshipServiceId = 0;
    }

    public static fromJson (json: any): ServiceTypeModel {
        const shiftType = new ServiceTypeModel;
        Object.assign(shiftType,{
            id: json.id,
            name: json.name,
            isActive: json.is_active ?? true,
            shiftId: json.shift_type_id,
            rateType: json.rate_type ?? '',
            chargeRateScopeId: json.charge_rate_scope_id,
            payRateScopeId: json.pay_rate_scope_id,
            categoryId: json.category_id,
            timeWindows: json.time_windows ?? ['','','',''],
            breakDuration: json.break_duration ?? [0,0],
            serviceDuration: json.service_duration ?? [0,0],
            roles: json.roles ?? [],
            vehicleTypes: [],
            machshipServiceId: json.machship_service_id ?? 0
        })
        return shiftType;
    }
}